/*!

=========================================================
* Argon Dashboard Chakra PRO - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-chakra-pro
* Copyright 2022 Creative Tim (https://www.creative-tim.com/)

* Designed and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

export const badgeStyles = {
  components: {
    Badge: {
      sizes: {
        md: {
          width: "65px",
          height: "25px",
        },
      },
      baseStyle: {
        textTransform: "capitalize",
      },
    },
  },
};
